.title {
  font:
    normal normal bold 1.75rem/2.0625rem Rubik,
    sans-serif;
}
